import { render, staticRenderFns } from "./cmp-dialog-regist.vue?vue&type=template&id=38fc86f9&scoped=true"
import script from "./cmp-dialog-regist.vue?vue&type=script&lang=js"
export * from "./cmp-dialog-regist.vue?vue&type=script&lang=js"
import style0 from "./cmp-dialog-regist.vue?vue&type=style&index=0&id=38fc86f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc86f9",
  null
  
)

export default component.exports